import { APP_EMITTER_EVENTS, AppEmitter, Checkbox } from "shared";
import { ITemplateCheckboxComponent } from "entities/template";
import React, { useEffect, useState } from "react";
import { ComponentTooltip, IComponentTooltipSettings } from "../component_tooltip/component_tooltip";
import { transformMarkdown } from "../../../../lib/utils/markdown";
import styles from "./document_form_checkbox.module.scss";

interface IDocumentFormCheckboxProps {
    component: ITemplateCheckboxComponent;
    onChange: (tag: string, value?: boolean) => void;
    externalUpdateRecord: Record<string, any>;
    label?: string;
    tooltip: IComponentTooltipSettings;
    readonly: boolean;
}

export const DocumentFormCheckbox: React.FC<IDocumentFormCheckboxProps> = React.memo(({
                                                                                          component,
                                                                                          label,
                                                                                          tooltip,
                                                                                          readonly,
                                                                                          externalUpdateRecord,
                                                                                          onChange,
                                                                                      }) => {
    const [value, setValue] = useState<boolean | undefined>();

    useEffect(() => {
        setTimeout(() => {
            const externalVal = externalUpdateRecord[component.name];
            if (!(externalVal || typeof externalVal === "boolean")) {
                if (typeof component.defaultValue === "boolean") {
                    setValue(component.defaultValue)
                } else {
                    setValue(false);
                }
            }
        }, 100)
        return () => {
            onChange(component.name, undefined);
        }
    }, [])

    useEffect(() => {
        AppEmitter.on(APP_EMITTER_EVENTS.clearForm, handleClearEvent);
        return () => {
            AppEmitter.off(APP_EMITTER_EVENTS.clearForm, handleClearEvent);
        }
    }, [])

    useEffect(() => {
        if (component.name) {
            const val = externalUpdateRecord[component.name];
            if (val === true || val === "true") {
                setValue(true);
            } else {
                setValue(false);
            }
        }
    }, [externalUpdateRecord, component.name])

    useEffect(() => {
        if (component.name) {
            onChange(component.name, value);
        }
    }, [component.name, value])

    const handleClearEvent = () => {
        if (!readonly) {
            setValue(false);
        }
    }

    return component.name ?
        <div className={styles.container}>
            <Checkbox
                className={styles.input}
                label={transformMarkdown(label)}
                size="m"
                onChange={() => setValue(prevState => !prevState)}
                checked={value}
                disabled={readonly}
            />
            <ComponentTooltip tooltip={tooltip} id={component.id.toString()} className={styles.tooltip}/>
        </div>
        : null;
});
